import React from 'react';
import { RefreshButton } from '../../components/Buttons/Buttons';
import './DeviceInfoDescriptionHeader.css';

interface DeviceInfoDescriptionHeaderProps {
	description: string;
	learnMoreUrl?: string;
	learnMoreText?: string;
	onRefresh: () => void;
	isRefreshing: boolean;
}

export const DeviceInfoDescriptionHeader: React.FC<DeviceInfoDescriptionHeaderProps> = ({
	description,
	learnMoreUrl,
	learnMoreText = 'Learn more',
	onRefresh,
	isRefreshing,
}) => {
	return (
		<div className="device-info-description-header">
			<div className="device-info-description-content">
				<span className="device-info-description-text">{description}</span>
				{learnMoreUrl && (
					<>
						{' '}
						<a
							href={learnMoreUrl}
							target="_blank"
							rel="noopener noreferrer"
							className="device-info-learn-more-link"
						>
							{learnMoreText}
						</a>
					</>
				)}
			</div>
			<RefreshButton onRefresh={onRefresh} isRefreshing={isRefreshing} />
		</div>
	);
};
